import axios from 'axios'
import { Baseurl } from '../../constants/env'
import { spinerLog } from '../../features/spinner'
import Loader from '../../components/common/spinner/Loader'
import { dispatch, getState } from '../../features/store'; 

axios.defaults.withCredentials = false
const {spinner} = getState().spin.spinner 
const unInterceptedAxiosInstance = axios.create({
    withCredentials: true
  }) 
let serviceCount = 0
const interceptor = async () => {
  axios.interceptors.request.use(
    (config) => {
      console.log('im from interceptor');
      if (serviceCount === 0) {
        // store.dispatch('loginModule/SHOW_LOADER_ACTION')
        // dispatch(spinerLog(true))
        // {spinner ? <Loader /> : <></>}
      }
      const accessToken = localStorage.getItem('token')
      if (accessToken) { 
        config.headers.Authorization = `Bearer ${accessToken}`
      }     
      serviceCount++
      console.log(config,'config from the interceptor');
      
      return config
    },
    (error) => {
      serviceCount--
      return Promise.reject(error)
    }
  )
  axios.interceptors.response.use((response) => {
    serviceCount--
    if (serviceCount <= 0) {
    //   store.dispatch('loginModule/HIDE_LOADER_ACTION')
   // dispatch(spinerLog(false))
   // {spinner ? <Loader /> : <></>}
    }
    return response
  },
  async (error) => {
    serviceCount--
    if (serviceCount <= 0) {
    //   store.dispatch('loginModule/HIDE_LOADER_ACTION')
   //dispatch(spinerLog(false))
    }
    const prevRequest = error?.config
    if ((error?.response?.status === 403 || error?.response?.status === 401) && !prevRequest.sent) {
      prevRequest.sent = true
      let redirectUrl = window.location.pathname
      try {  
        // await store.dispatch('loginModule/REFRESH_TOKEN_ACTION', redirectUrl)  
        let res = await unInterceptedAxiosInstance.post(`${Baseurl}/refreshtoken`) 
         localStorage.setItem('token',res.data.accessToken)
        const accessToken = localStorage.getItem('token')
        prevRequest.headers["Authorization"] = `Bearer ${accessToken}`
        return axios(prevRequest)
      } catch (error) {
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)}

export default interceptor
